module.exports = __webpack_public_path__ + "static/media/34.faa8cac2.jpg";